import { combineReducers } from 'redux';
import initialState from './initialState';
import auth from '../../utils/auth';
import AppFlowActions from '../../constants';
import login from './login';
import isLoading from './loading';

const appReducer = combineReducers({
  login,
  isLoading,
});

function rootReducer(state, action) {
  if (action.type === AppFlowActions.LOGOUT_REQUEST) {
    auth.logout();
    return initialState;
  }

  return appReducer(state, action);
}

export default rootReducer;
